<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p37"><span><a href="#/Contents#rp37">GOLDEN CARROT SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Orange juice adds a subtle sweetness to this carrot soup.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>8 medium carrots, sliced</span></p>
<p class="hang"><span>1 cup coarsely chopped onion</span></p>
<p class="hang"><span>1 tablespoon margarine or butter</span></p>
<p class="hang"><span>3 cups Chicken Stock (see <a href="#/Chapter012#p2">p. 2</a>)</span></p>
<p class="hang"><span>½ cup fresh orange juice</span></p>
<p class="hang"><span><a id="page_29"></a>1 strip orange zest</span></p>
<p class="hang"><span>¼ cup dry sherry or orange juice</span></p>
<p class="hang"><span>1 tablespoon sugar</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>6 thin slices orange</span></p>
<p class="normalt"><span><b>1.</b> Sauté carrots and onion in margarine in large saucepan 10 minutes. Add stock, orange juice, and orange zest and heat to boiling. Reduce heat and simmer, covered, until carrots are tender, about 20 minutes. Process soup in food processor or blender until smooth; add sherry and sugar. Season to taste with salt and white pepper; garnish each bowl of soup with orange slices.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 109</span></p>
<p class="per1"><span>% calories from fat: 20</span></p>
<p class="per1"><span>Protein (g): 2.3</span></p>
<p class="per1"><span>Carbohydrate (g): 18</span></p>
<p class="per1"><span>Fat (g): 2.5</span></p>
<p class="per1"><span>Saturated fat (g): 0.5</span></p>
<p class="per1"><span>Cholesterol (mg): 1.7</span></p>
<p class="per1"><span>Sodium (mg): 60</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.5</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
<p class="normalt"><span><span class="small">VARIATION</span></span></p>
<p class="normala" id="p37a"><span><b>Orange Sweet Potato Soup</b> — Make soup as above, substituting 2 peeled, cubed medium sweet potatoes for the carrots. Omit sherry and add ½ teaspoon ground cinnamon and a pinch each ground nutmeg and mace.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0219.vue?37887f69